var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-resources" },
    [
      _vm.resources.length > 0
        ? _c("h2", { staticClass: "t-text-style-gamma t-margin-bottom-s" }, [
            _vm._v("Dokumentation och hjälpmedel")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.resources, function(resource) {
        return [
          _c(
            "resource-item",
            _vm._b(
              {
                attrs: {
                  "process-id": _vm.processId,
                  "process-type": _vm.processType,
                  "process-step-id": _vm.processStepId,
                  "resource-id": resource.id,
                  sortIndex: _vm.getSortIndexForResource(
                    _vm.resources,
                    resource
                  ),
                  sortIndexes: _vm.getSortIndexes(_vm.resources)
                },
                on: {
                  editResource: _vm.editResource,
                  deleteResource: _vm.deleteResource,
                  sortResources: _vm.sortResources
                }
              },
              "resource-item",
              resource,
              false
            )
          )
        ]
      }),
      _vm._v(" "),
      _c(
        "can",
        { attrs: { i: "manage", a: _vm.processType } },
        [
          !_vm.showCreate
            ? _c(
                "button",
                {
                  staticClass: "c-button c-button--secondary t-margin-top-s",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.toggleShowCreate($event)
                    }
                  }
                },
                [_vm._v("Lägg till dokumentation")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showCreate
            ? _c("resource-item", {
                attrs: { mode: "create", "process-step-id": _vm.processStepId },
                on: {
                  createResource: _vm.createResource,
                  toggleShowCreate: _vm.toggleShowCreate
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }